<main class="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-10">
  <section class="w-full max-w-[1040px] bg-white border border-slate-200 rounded-lg shadow-xl overflow-hidden grid lg:grid-cols-[0.95fr_1.05fr]">
    <div class="relative min-h-[280px] lg:min-h-[510px] bg-blue-950 text-white px-8 py-10 flex flex-col justify-between">
      <div class="absolute inset-0 opacity-15 bg-[radial-gradient(circle_at_20%_20%,#38bdf8_0,transparent_32%),radial-gradient(circle_at_85%_15%,#f59e0b_0,transparent_30%),radial-gradient(circle_at_50%_85%,#22c55e_0,transparent_36%)]"></div>

      <div class="relative z-10">
        <div class="flex items-center gap-3">
          <div class="h-12 w-12 rounded-lg bg-white/95 flex items-center justify-center shadow-sm">
            <span class="material-symbols-outlined text-blue-950 text-[30px]">admin_panel_settings</span>
          </div>
          <div class="leading-tight">
            <p class="text-base font-bold">ក្រសួងទេសចរណ៍</p>
            <p class="text-xs uppercase tracking-wide text-blue-100">Admin Portal</p>
          </div>
        </div>
      </div>

      <div class="relative z-10 max-w-md">
        <p class="text-sm font-semibold uppercase tracking-wide text-blue-100">Secure access</p>
        <h1 class="mt-3 text-4xl font-bold leading-tight">Welcome MOT Admin</h1>
        <p class="mt-4 text-sm leading-6 text-blue-50">
          Manage Ministry of Tourism content, languages, menus, news, and destination data from one focused workspace.
        </p>
      </div>

      <div class="relative z-10 grid grid-cols-3 gap-3 text-sm"></div>
    </div>

    <div class="px-6 py-8 sm:px-12 lg:px-14 flex items-center">
      <form class="w-full max-w-md mx-auto" (ngSubmit)="login()" #loginForm="ngForm" novalidate>
        <div>
          <!-- <p class="text-sm font-semibold text-blue-700">Sign in</p> -->
          <h2 class="mt-2 text-3xl font-bold text-slate-900">
            {{ loginStep === 'credentials' ? 'Admin login' : '2FA Code Confirmation' }}
          </h2>
          <p class="mt-2 text-sm text-slate-500">
            {{ loginStep === 'credentials' ? 'Enter your account details to continue.' : 'Enter your 2FA code to finish signing in.' }}
          </p>
        </div>

        <div *ngIf="errorMessage" class="mt-6 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>

        <div *ngIf="loginStep === 'credentials'" class="mt-7 space-y-5">
          <label class="block">
            <span class="text-sm font-semibold text-slate-700">Username</span>
            <span class="mt-2 flex items-center gap-3 rounded-md border border-slate-300 bg-white px-3.5 py-3 focus-within:border-blue-600 focus-within:ring-2 focus-within:ring-blue-100">
              <span class="material-symbols-outlined text-[20px] text-slate-400">person</span>
              <input
                class="w-full border-0 p-0 text-sm text-slate-900 placeholder:text-slate-400 focus:ring-0"
                type="text"
                name="username"
                [(ngModel)]="username"
                autocomplete="username"
                placeholder="Enter username"
                required>
            </span>
          </label>

          <label class="block">
            <span class="text-sm font-semibold text-slate-700">Password</span>
            <span class="mt-2 flex items-center gap-3 rounded-md border border-slate-300 bg-white px-3.5 py-3 focus-within:border-blue-600 focus-within:ring-2 focus-within:ring-blue-100">
              <span class="material-symbols-outlined text-[20px] text-slate-400">lock</span>
              <input
                class="w-full border-0 p-0 text-sm text-slate-900 placeholder:text-slate-400 focus:ring-0"
                [type]="showPassword ? 'text' : 'password'"
                name="password"
                [(ngModel)]="password"
                autocomplete="current-password"
                placeholder="Enter password"
                required>
              <button
                class="h-8 w-8 shrink-0 rounded-md text-slate-500 hover:bg-slate-100 flex items-center justify-center"
                type="button"
                (click)="togglePassword()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <span class="material-symbols-outlined text-[20px]">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </span>
          </label>
        </div>

        <div *ngIf="loginStep === 'twoFactor'" class="mt-7 space-y-5">
          <div class="rounded-md border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-800">
            Verifying <span class="font-semibold">{{ pendingEmail || username }}</span>.
          </div>

          <div *ngIf="qrCodeImageSrc" class="flex justify-center rounded-md border border-slate-200 bg-white p-4">
            <img class="h-44 w-44 object-contain" [src]="qrCodeImageSrc" alt="Two-factor setup QR code">
          </div>

          <label class="block">
            <span class="text-sm font-semibold text-slate-700">2FA Code</span>
            <span class="mt-2 flex items-center gap-3 rounded-md border border-slate-300 bg-white px-3.5 py-3 focus-within:border-blue-600 focus-within:ring-2 focus-within:ring-blue-100">
              <span class="material-symbols-outlined text-[20px] text-slate-400">pin</span>
              <input
                class="w-full border-0 p-0 text-sm text-slate-900 placeholder:text-slate-400 focus:ring-0"
                type="text"
                name="twoFactorCode"
                [(ngModel)]="twoFactorCode"
                inputmode="numeric"
                autocomplete="one-time-code"
                placeholder="Enter 2FA code"
                required>
            </span>
          </label>

          <button
            class="text-sm font-semibold text-slate-500 hover:text-blue-800"
            type="button"
            (click)="backToLogin()">
            Use different account
          </button>
        </div>

        <button
          class="mt-8 w-full h-12 rounded-md bg-blue-900 text-white font-bold text-sm flex items-center justify-center gap-2 hover:bg-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300"
          type="submit"
          [disabled]="!canSubmit">
          <span *ngIf="!isSubmitting" class="material-symbols-outlined text-[20px]">
            {{ loginStep === 'credentials' ? 'login' : 'verified_user' }}
          </span>
          <span *ngIf="isSubmitting" class="h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span>
          {{
            isSubmitting
              ? (loginStep === 'credentials' ? 'Signing in...' : 'Verifying...')
              : (loginStep === 'credentials' ? 'Sign in' : 'Verify code')
          }}
        </button>
      </form>
    </div>
  </section>
</main>
